import { useEffect } from 'react';

import type { API } from '@client/api/types';

interface UseAgentEnteredConsentStatusChangeOptions {
  request: API.AgentEnteredIntakeRequest | null;
  isConsented: boolean;
  onConsentStatusChange?: (isConsented: boolean) => void;
}

export function useAgentEnteredConsentStatusChange({
  request,
  isConsented,
  onConsentStatusChange,
}: UseAgentEnteredConsentStatusChangeOptions) {
  useEffect(() => {
    if (!request) return;
    onConsentStatusChange?.(isConsented);
  }, [isConsented, onConsentStatusChange, request]);
}
